<template>
  <div>
    <!-- <img src="../assets/images/bg.png" alt="bg1" class="background-image1" /> -->
    <transition
      appear
      @before-enter="$animations.beforeEnterLogoArea"
      @enter="$animations.enterLogoArea"
    >
      <Logo style="margin-bottom: 20vh"></Logo>
    </transition>
    <div class="card px-2 cardClass"  >
      <transition
        appear
        @before-enter="$animations.beforeEnterAbove"
        @enter="$animations.enterAbove"
      >
        <div class="columns is-centered pt-5">
          <div
            class="column is-four-fifths pt-5 ps-3"
            style="text-align: center"
          >
            <p
              :class="`text-center  ${
                $root.selectedLanguage === `ta`
                  ? `ta-he-line`
                  : $root.selectedLanguage === `si`
                  ? `si-he-specific-line`
                  : `en-he-line`
              }`"
              style="font-family: OpenSans-Bold;  "
            >
              {{ $root.selectedLanguageData.confirmYourEmail }}
            </p>
            <p
              :class="`${
                $root.selectedLanguage === `ta`
                  ? `ta-sub-line`
                  : $root.selectedLanguage === `si`
                  ? `si-sub-line`
                  : `en-sub-line`
              }`"
              style="font-family: OpenSans-Bold; "
            >
              {{ $root.selectedLanguageData.wehavesentanOTPto }}
            </p>
            <div v-if="$root.isPreviouslyDonorFilled ===1"
              :style="{
                'text-align': 'center',
                'text-justify': 'inter-word',
                'word-break': 'break-all',
              }"
            >
              {{ $root.formData.guardian_email  || $root.formData.statusEmail  || "youremail@gmail.com" }}
            </div>

            <div v-else
              :style="{
                'text-align': 'center',
                'text-justify': 'inter-word',
                'word-break': 'break-all',
              }"
            >
              {{ $root.formData.email  || $root.formData.statusEmail  || "youremail@gmail.com" }}
            </div>
          </div>
        </div>
      </transition>
      <ValidationObserver v-slot="{ invalid }">
        <form @submit.prevent="onSubmit">
          <div class="columns is-centered">
            <div class="column is-four-fifths">
              <transition
                appear
                @before-enter="$animations.beforeEnterBelow"
                @enter="$animations.enterBelow"
              >
                <div class="mb-1" >
                  <label
                    :class="`${
                      $root.selectedLanguage === `ta`
                        ? `ta-label`
                        : $root.selectedLanguage === `si`
                        ? `si-label`
                        : ``
                    }`"
                    style="font-size: 1.0rem !important;"
                  >
                    {{
                      $root.selectedLanguageData
                        .pleaseCheckYourMailboxAndEnterTheOTPCodeBelow
                    }}</label
                  >
                  <b-field>
                    <ValidationProvider
                      name="OTP"
                      :rules="{ length: 6, required: true }"
                      v-slot="{ errors }"
                    >
                      <p class="control has-icons-right">
                        <b-input type="text" v-model="$root.formData.otp" />
                        <span class="icon is-small is-right mr-4">
                          <img
                            src="../assets/images/icons/Blue/otp.png"
                            alt="otp-img"
                            width="30"
                            height="30"
                          />
                        </span>
                      </p>
                      <span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-field>
                </div>
              </transition>
              <transition
                appear
                @before-enter="$animations.beforeEnterBelow"
                @enter="$animations.enterBelow"
              >
                <div class="columns is-mobile">
                  <div class="column">
                    <p style="text-align: start">
                      {{ $root.selectedLanguageData.didnotReceive }}
                    </p>
                  </div>
                  <div class="column">
                    <p style="text-align: end">
                      {{ $root.selectedLanguageData.resendOTPin }}
                      <span style="color: #009ec2; font-family: OpenSans-Bold"
                        >{{ countDown }} s</span
                      >
                    </p>
                  </div>
                </div>
              </transition>
<!--              v-if="$root.kycFieldVisibility.email"-->
              <div v-if="!isPreviousRouteEnterName">
                <transition
                  appear
                  @before-enter="$animations.beforeEnterBelow"
                  @enter="$animations.enterBelow"
                >
                  <p>
                    <!--                Change your-->
                    {{ $root.selectedLanguageData.changeYourEmailPhase1 }}
                    <span
                    @click="
                      () => {
                        yourNewMail = $root.formData.email;
                        isModalActive = true;
                      }
                    "
                      :style="{
                        color: '#009ec2',
                        'font-family': 'OpenSans-Bold',
                        'letter-spacing': '0.5px',
                        'text-decoration': 'underline',
                        cursor: 'pointer',
                      }"
                    >
                      <!--                  email address -->
                      {{ $root.selectedLanguageData.changeYourEmailPhase2 }}
                    </span>
                  </p>
                </transition>
                <b-modal v-model="isModalActive" :width="500" scroll="keep">
                  <div class="card">
                    <header class="modal-card-head">
                      <div class="is-size-4" style="text-align: center">
                        {{ $root.selectedLanguageData.changeYourEmailAddress }}
                      </div>

                      <div class="modal-close-button">
                        <button
                          class="delete"
                          aria-label="close"
                          @click="isModalActive = false"
                        ></button>
                      </div>
                    </header>
                    <div class="card-content mx-4">
                      <div>
                        {{ $root.selectedLanguageData.emailChangeConditon }}
                      </div>
                      <div class="mt-2">
                        <label
                          :class="`${
                            $root.selectedLanguage === `ta`
                              ? `ta-label`
                              : $root.selectedLanguage === `si`
                              ? `si-label`
                              : ``
                          }`"
                          >{{ $root.selectedLanguageData.newEmailLable
                          }}<span class="has-text-danger">*</span></label
                        >
                        <b-field>
                          <p class="control has-icons-right">
                            <ValidationProvider
                              :rules="{ email: true, required: true }"
                              v-slot="{ errors, valid }"
                            >
                              <p class="calEmailError">
                                {{
                                  valid
                                    ? ($root.isEmailError = valid)
                                    : ($root.isEmailError = valid)
                                }}
                              </p>
                              <b-input
                                type="email"
                                @focus="$inputFocused('email')"
                                @input="$inputChanged('email')"
                                @blur="$inputBlured('email')"
                                v-model="yourNewMail"
                              />
                              <span class="icon is-small is-right mr-2">
                                <!-- <img
                                src="../assets/images/icons/Yellow/Group 156.png"
                                alt="contact-name-img"
                                width="25"
                                height="25"
                              /> -->
                              </span>
                              <span class="has-text-danger">{{
                                errors[0]
                              }}</span>
                            </ValidationProvider>
                          </p>
                        </b-field>
                      </div>

                    </div>

                  </div>
                </b-modal>
              </div>
              <div class="downButtons" >
              <transition
                  appear
                  @before-enter="$animations.beforeEnterBelow"
                  @enter="$animations.enterBelow"
              >
                <div>
                  <!--            <div class="column is-centered is-10 is-offset-4">-->
                  <div

                      style="display:flex; justify-content: center; margin-bottom:10px"
                  >
<!--                    <div
                        :class="`is-flex-direction-row-reverse buttons`"
                    >-->
                    <b-button
                        class="resend-button"
                        @click="emailButtonAction"
                        :disabled="forThreeMinutes"
                    >{{ $root.selectedLanguageData.resend }}</b-button
                    >
                      <b-button
                          :class="` ${
                      $root.selectedLanguage === `ta`
                        ? `back-button-ta`
                        : $root.selectedLanguage === `si`
                        ? `back-button-si`
                        : `back-button-en`
                    }`"
                          @click="goToPreviousPage"
                      >{{ $root.selectedLanguageData.back }}</b-button
                      >

                    <b-button
                        :class="`is-primary  ${
                      $root.selectedLanguage === `ta`
                        ? `continue-button-ta`
                        : $root.selectedLanguage === `si`
                        ? `continue-button-si`
                        : `continue-button-en`
                    }`"
                        :disabled="invalid"
                        @click="goToNextPage"
                    >{{ $root.selectedLanguageData.continue }}</b-button>
                  </div>
                </div>
              </transition>
          </div>

            </div>
          </div>


        </form>
      </ValidationObserver>
      <b-modal v-model="isModalActive" :width="500" scroll="keep">
        <div class="card">
          <header class="modal-card-head">
            <div class="is-size-4" style="text-align: center">
              {{ $root.selectedLanguageData.changeYourEmailAddress }}
            </div>

             <div class="modal-close-button">
              <button
                class="delete"
                aria-label="close"
                @click="isModalActive = false"
              ></button>
            </div>
          </header>
          <div class="card-content mx-4">
            <div>
              {{ $root.selectedLanguageData.emailChangeConditon }}
            </div>
            <div class="mt-2">
              <label
                :class="`${
                  $root.selectedLanguage === `ta`
                    ? `ta-label`
                    : $root.selectedLanguage === `si`
                    ? `si-label`
                    : ``
                }`"
                >{{ $root.selectedLanguageData.newEmailLable
                }}<span class="has-text-danger">*</span></label
              >
              <b-field>
                <p class="control has-icons-right">
                  <ValidationProvider
                    :rules="{ email: true, required: true }"
                    v-slot="{ errors, valid }"
                  >
                    <p class="calEmailError">
                      {{
                        valid
                          ? ($root.isEmailError = valid)
                          : ($root.isEmailError = valid)
                      }}
                    </p>
                    <b-input type="email" v-model="yourNewMail" />
                    <span class="icon is-small is-right mr-2">
                      <img
                        src="../assets/images/icons/Blue/Group 156.png"
                        alt="contact-name-img"
                        width="25"
                        height="25"
                      />
                    </span>
                    <span class="has-text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </p>
              </b-field>
            </div>
            <b-button
              class="mt-6"
              type="is-primary"
              expanded
              @click="
                () => {
                  isModalActive = false;
                  $root.formData.email = yourNewMail;
                }
              "
              :disabled="!$root.isEmailError"
              >{{ $root.selectedLanguageData.changeEmailAdd }}</b-button
            >
          </div>
        </div>
      </b-modal>
    </div>
    <GetHelp v-if="false"></GetHelp>
  </div>
</template>
<script>
import GetHelp from "./GetHelp.vue";
import Logo from "./NsbKycLogo.vue";
import {submitPageInputs} from "@/util/util";

export default {
  components: {
    GetHelp,
    Logo,
  },
  props: {
    email: String, // Define the type of the prop
  },




  data() {
    return {
      yourNewMail: "",
      forThreeMinutes: false,
      countDown: "",
      isModalActive: false,
      previousRoute : "",
      submitPageInputs : submitPageInputs,
      isContinueButtonLoading : false

    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.previousRoute = from;
      console.log(vm.previousRoute," previousRoute")
    });
  },
  methods: {

    sendNicCheckOTP(){

      try {
        window.element = this;

        let otherNamesSplited = this.$root.formData.other_name
            .trim()
            .split(" ");
        let firstName = otherNamesSplited[0];
        console.log("First name to send email : " + firstName);

       let data= {
         email: "hansakanirmal123@gmail.com",
         name: "Nirmal",
         nicNumber: this.$root.formData.userEnteredNic
       }

        this.$http
            .post(this.$baseURL +"/kycForm/sendStatusCheckOTPEmail", data)
        // this.$http
        //     .post(
        //         this.$baseURL + "/kycForm/verifyNicExistsStatusCheck",
        //         {
        //           // email: this.$root.formData.email,
        //           // name: firstName,
        //           nicNumber: this.$root.formData.userEnteredNic
        //
        //         },
        //
        //     )


            .then((response) => {
              if (response.data.success) {
                // this.$root.formData.initialOTP = response.data.data.otp;
              } else {
                console.log(response.data);
                this.$buefy.toast.open({
                  message: "Failed to send OTP email",
                  type: "is-danger",
                });
              }
            })
            .catch((response) => {
              this.$buefy.toast.open({
                message: response.message,
                type: "is-danger",
              });
            });
      } catch (e) {
        this.$buefy.toast.open({
          message: "Failed to send OTP email",
          type: "is-danger",
        });
      }

    },

    sendInitialOTP() {
      let email = this.$root.isPreviouslyDonorFilled === 0 ? this.$root.formData.email : this.$root.formData.guardian_email

      try {
        window.element = this;

        let otherNamesSplited = this.$root.formData.other_name
          .trim()
          .split(" ");
        let firstName = otherNamesSplited[0];
        console.log("First name to send email : " + firstName);
        let kyc_token =
          this.$root.formData.kyc_token +
          "." +
          this.$root.formData.color_code4 +
          "." +
          this.$root.formData.color_code12;

        this.$http
          .post(
            this.$baseURL + "/kycForm/sendInitialOTPEmail",
            {
              email: email,
              name: firstName,

            },
            {
              headers: { "X-token": kyc_token },
            }
          )


          .then((response) => {
            if (response.data.success) {
              // this.$root.formData.initialOTP = response.data.data.otp;
            } else {
              console.log(response.data);
              this.$buefy.toast.open({
                message: "Failed to send OTP email",
                type: "is-danger",
              });
            }
          })
          .catch((response) => {
            this.$buefy.toast.open({
              message: response.message,
              type: "is-danger",
            });
          });
      } catch (e) {
        this.$buefy.toast.open({
          message: "Failed to send OTP email",
          type: "is-danger",
        });
      }
    },
    sendStatusCheckOTPEmail() {

      try {
        window.element = this;
        let email = this.$root.formData.statusEmail;

        let otherNamesSplited = this.$root.formData.other_name
            .trim()
            .split(" ");
        let firstName = otherNamesSplited[0];
        console.log("First name to send email : " + firstName);
        console.log("email " ,email);

        this.$http
            .post(
                this.$baseURL + "/sendStatusCheckOTPEmail",
                {
                  email: this.$root.formData.statusEmail,
                  name: firstName,
                  nic:this.$root.formData.statusNic,


                },
                /*{
                  headers: { "X-token": kyc_token },
                }*/
            )


            .then((response) => {
              if (response.data.success) {
                // this.$root.formData.initialOTP = response.data.data.otp;
                this.$buefy.toast.open({

                  message: "OTP sent succesfully to email",
                  type: "is-success",
                });
              } else {
                console.log(response.data);
                this.$buefy.toast.open({
                  message: "Failed to send OTP email",
                  type: "is-danger",
                });
              }
            })
            .catch((response) => {
              this.$buefy.toast.open({
                message: response.message,
                type: "is-danger",
              });
            });
      } catch (e) {
        this.$buefy.toast.open({
          message: "Failed to send OTP email",
          type: "is-danger",
        });
      }
    },


    validateStatusCheckOTP(){
      try {
        window.element = this;
        /*let kyc_token =
            this.$root.formData.kyc_token +
            "." +
            this.$root.formData.color_code4 +
            "." +
            this.$root.formData.color_code12;*/
        this.$http
            .post(
                this.$baseURL + "/validateStatusCheckOTP",
                {
                  nicNumber : this.$root.formData.statusNic,
                  otp_code: this.$root.formData.otp,
                },
                /*{
                  headers: { "X-token": kyc_token },
                }*/
            )
            .then((response) => {
              if (response.data.success == true) {
                this.invalid = false;
                this.$buefy.toast.open({
                  message: "Entered OTP Matched",
                  type: "is-primary",
                });
                this.$router.push( 'welcome-back')
                /*if(this.previousRoute.fullPath === "enter-name"){
                  this.$router.push("welcome-back");
                }
                else{
                  this.$router.push("personal-info");
                }*/

                // this.previousNavigationChecker()
              } else {
                this.$buefy.toast.open({
                  message: "Entered OTP does not match with OTP sent in email ",
                  type: "is-danger",
                });
                this.invalid = true;
              }
            })
            .catch((response) => {
              this.$buefy.toast.open({
                message: response.message,
                type: "is-danger",
              });
            });
      } catch (e) {
        this.$buefy.toast.open({
          message: "Failed to send OTP email",
          type: "is-danger",
        });
      }

    },

    validateOTP(){
      try {
        window.element = this;
        let kyc_token =
            this.$root.formData.kyc_token +
            "." +
            this.$root.formData.color_code4 +
            "." +
            this.$root.formData.color_code12;
        this.$http
            .post(
                this.$baseURL + "/kycForm/validateOTP",
                {
                  otp_code: this.$root.formData.otp,
                },
                {
                  headers: { "X-token": kyc_token },
                }
            )
            .then((response) => {
              if (response.data.success == true) {
                this.invalid = false;
                if(this.previousRoute.fullPath === "enter-name"){
                  this.$router.push("welcome-back");
                }
                else{

                  if(this.$root.formData.childrenAccountOpeningPurpose === "For my own child" || this.$root.formData.haveNic === 'No'){
                    // this.$router.push("account-holder-info");
                    this.submitPageInputs(this.isContinueButtonLoading, 'account-holder-info', 'account-info', 'account-holder-info', 1)
                  }
                  else if (this.$root.formData.childrenAccountOpeningPurpose === "For another person's child (Gift Account)"){
                    // this.$router.push("guardians_information")
                    this.submitPageInputs(this.isContinueButtonLoading, 'guardians_information', 'account-info', 'guardians_information', 1)
                  }
                  else {
                    this.$router.push("personal-info");
                    this.submitPageInputs(this.isContinueButtonLoading, 'personal-info', 'account-info', 'personal-info', 1)
                  }
                }

                // this.previousNavigationChecker()
              } else {
                this.$buefy.toast.open({
                  message: "Entered OTP does not match with OTP sent in email ",
                  type: "is-danger",
                });
                this.invalid = true;
              }
            })
            .catch((response) => {
              this.$buefy.toast.open({
                message: response.message,
                type: "is-danger",
              });
            });
      } catch (e) {
        this.$buefy.toast.open({
          message: "Failed to send OTP email",
          type: "is-danger",
        });
      }


    },

    goToNextPage(){
      if(this.previousRoute.fullPath === "/enter-name"){
          this.validateStatusCheckOTP();
      }
      else {
        this.validateOTP();
      }

    },
    previousPageEnterName(){

      this.$router.push("/enter-name");
    },
    previousPageNotEnterName(){
      this.$router.push("/account-info");
    },

    goToPreviousPage(){
      if(this.previousRoute.fullPath == "/enter-name"){
        this.previousPageEnterName();
      }
      else {
        this.previousPageNotEnterName();


      }
    },



    // goToPersonalInfoPage() {
      // let endPoint = ""
      // if(this.previousRoute.fullPath === "enter-name"){
      //   endPoint = "/kycForm/validateStatusCheckOTP"
      // }
      // else {
      //   endPoint ="/kycForm/validateOTP"
      //
      // }
      // if (this.$root.formData.otp == this.$root.formData.initialOTP) {
      //   this.invalid = false;
      //   this.$router.push("persional-info");
      // } else {
      //   this.$buefy.toast.open({
      //     message: "Entered OTP does not match with OTP sent in email ",
      //     type: "is-danger",
      //   });
      //
      //   this.invalid = true;
      // }
    //   try {
    //     window.element = this;
    //     let kyc_token =
    //       this.$root.formData.kyc_token +
    //       "." +
    //       this.$root.formData.color_code4 +
    //       "." +
    //       this.$root.formData.color_code12;
    //     this.$http
    //       .post(
    //         this.$baseURL + "/kycForm/validateOTP",
    //         {
    //           otp_code: this.$root.formData.otp,
    //         },
    //         {
    //           headers: { "X-token": kyc_token },
    //         }
    //       )
    //       .then((response) => {
    //         if (response.data.success == true) {
    //           this.invalid = false;
    //           if(this.previousRoute.fullPath === "enter-name"){
    //             this.$router.push("welcome-back");
    //           }
    //           else{
    //             this.$router.push("personal-info");
    //           }
    //
    //           // this.previousNavigationChecker()
    //         } else {
    //           this.$buefy.toast.open({
    //             message: "Entered OTP does not match with OTP sent in email ",
    //             type: "is-danger",
    //           });
    //           this.invalid = true;
    //         }
    //       })
    //       .catch((response) => {
    //         this.$buefy.toast.open({
    //           message: response.message,
    //           type: "is-danger",
    //         });
    //       });
    //   } catch (e) {
    //     this.$buefy.toast.open({
    //       message: "Failed to send OTP email",
    //       type: "is-danger",
    //     });
    //   }
    // },


    emailButtonAction: function () {
      console.log("previous path",this.previousRoute.fullPath === "/enter-name", this.previousRoute.fullPath)
       if(this.previousRoute.fullPath === "/enter-name"){
        this.sendStatusCheckOTPEmail()
       }
       else  {

         this.sendInitialOTP();

       }


      this.forThreeMinutes = true;
      this.countDown = 60;
      this.timerCount();
      setTimeout(() => {
        this.forThreeMinutes = false;
      }, 60000);
    },

    timerCount: function () {
      if (this.countDown > 0) {
        setTimeout(() => {
          this.countDown -= 1;
          this.timerCount();
        }, 1000);
      }
    },
    checkUpdateLastStep(){
      if(this.previousRoute.fullPath === "/enter-name"){
        console.log('previous path --- enter name');
      }
      else {
        this.updateLastStep();
      }
    },



    updateLastStep() {
      try {
        window.element = this;
        let kyc_token =
          this.$root.formData.kyc_token +
          "." +
          this.$root.formData.color_code4 +
          "." +
          this.$root.formData.color_code12;

        if(this.previousRoute.fullPath === "enter-name"){
          this.$lastStepName='welcome back';
        }
        else{
          this.$lastStepName='Account Info'
        }
        this.$http
          .post(
            this.$baseURL + "/kycForm/updateInitialData",
            {
              last_step_name:this.$lastStepName,
              last_step: 1,
              email: this.$root.formData.email,
              name: this.$root.formData.full_name,
              contact_no: this.$root.formData.mobileNumber,
              nic_no: this.$root.formData.customer_nic,
            },
            {
              headers: { "X-token": kyc_token },
            }
          )
          .then((response) => {
            console.log(response.data);

            if (response.data.success) {
              console.log(response.data);
            } else {
              console.log(response.data);
            }
          })
          .catch((response) => {
            this.$buefy.toast.open({
              message: response.message,
              type: "is-danger",
            });
          });
      } catch (e) {
        this.$buefy.toast.open({
          message: "Failed to update last step",
          type: "is-danger",
        });
      }
    },
  },
  computed: {
    isPreviousRouteEnterName() {
      // Check if the previous route's fullPath is "/enter-name"
      console.log("previous path",this.previousRoute.fullPath === "/enter-name")
      return this.previousRoute.fullPath === "/enter-name";
    }
  },
  mounted: function () {
    this.$root.formData.otp = "";
    this.emailButtonAction();
    this.checkUpdateLastStep();
    this.yourNewMail = this.$root.formData.email;


  },
};
</script>
<style lang="scss" scoped>
.calEmailError {
  display: none;
}
.cardClass {
  width: 50%;
  margin: auto;
}

.downButtons{
  padding-top: 20px;
  margin: 10px 30px;
}
@media only screen and (max-width: 500px) {
  .cardClass {
    width: 90%;

  }
  .downButtons{
    margin: 10px 10px;
    padding: 5px 5px;
  }

}
</style>
